import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import { connect } from 'react-redux';
import { Builder } from './columnBuilder';
import { resendJobInvite } from '../../../../reducers/invites';
import { bindActionCreators } from 'redux';
import { sortByUserName, sortByStartDateThenName, sortByClientThenStart } from '../../../../utilities/sortJobExt';

import { workerTable, workerLink } from './_common';

class OnboardingList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sortColumn: 0,
            sortDesc: false,
            workers: []
        };
        this.changeSort = this.changeSort.bind(this);
        this.sortOnly = this.sortOnly.bind(this);
    }

    componentDidMount() {
        const { workers } = this.props;
        this.sortOnly(workers, sortByStartDateThenName);
    }

    UNSAFE_componentWillReceiveProps(props) {
        const { workers } = props;
        const { sortDesc } = this.state;

        this.sortOnly(workers, sortByStartDateThenName, sortDesc);
    }

    changeSort(comparer, columnIndex) {
        if (!comparer) {
            return;
        }
        let { sortColumn, sortDesc, workers } = this.state;

        if (columnIndex === sortColumn) {
            sortDesc = !sortDesc;
            this.setState({ sortDesc });
        } else {
            sortColumn = columnIndex;
            sortDesc = false;
            this.setState({ sortColumn, sortDesc });
        }
        this.sortOnly(workers, comparer, sortDesc);
    }

    sortOnly(workers, comparer, sortDesc = false) {
        const sortFunc = sortDesc ? (a, b) => comparer(b, a, true) : comparer;
        const sorted = [...workers.sort(sortFunc)];
        this.setState({ workers: sorted });
    }

    getColumn3(tenant) {
        switch (tenant) {
            case 'admin':
                return { builder: Builder.client, label: messages.client, sort: sortByClientThenStart };
            case 'client':
            default:
                return { builder: Builder.circleBasedStatus, label: messages.status };
        }
    }

    render() {
        const { resendJobInvite, history, tenant } = this.props;
        const { workers } = this.state;
        if (!workers) return null;

        const noneMessage = <FormattedMessage id={'noOnboardingWorkers'} defaultMessage={'No one currently onboarding.'} />;

        let columnDefinition = worker => (
            <div className="row clickable-row" onClick={() => workerLink(worker, history)}>
                {Builder.startDate(worker, 'col-xs-2 hidden-xs ellipsis')}
                {Builder.nameWithResend(worker, 'col-sm-4 col-xs-7 ellipsis', resendJobInvite)}
                {this.getColumn3(tenant).builder(worker, 'col-xs-3 hidden-xs ellipsis status')}
                {Builder.circle(worker, 'col-sm-3 col-xs-4 pull-right')}
            </div>
        );

        let headings = [
            { text: <FormattedMessage {...messages.starts} />, size: 'col-xs-2 hidden-xs ellipsis', sort: sortByStartDateThenName },
            { text: <FormattedMessage {...messages.worker} />, size: 'col-sm-4 col-xs-8', sort: sortByUserName },
            { text: <FormattedMessage {...this.getColumn3(tenant).label} />, size: 'col-xs-3 hidden-xs', sort: this.getColumn3(tenant).sort },
            { text: <FormattedMessage {...messages.progress} />, size: 'col-sm-3 col-xs-4 progress-label' }
        ];

        const { sortColumn, sortDesc } = this.state;
        return workerTable(messages.onboardingWorkers, workers, columnDefinition, headings, this.changeSort, sortColumn, sortDesc, noneMessage);
    }
}

OnboardingList.defaultProps = {
    workers: undefined,
    tenant: 'client'
};
OnboardingList.propTypes = {
    workers: PropTypes.array.isRequired
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            resendJobInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingList);



// WEBPACK FOOTER //
// ./src/pages/dashboard/components/workers/onboarding.jsx